import * as config from '../../../Config';

export const tryRefreshUserPermissions = async (token: string): Promise<void> => {
  try {
    const response = await fetch(config.powerBiApiUrl + 'v1.0/myorg/RefreshUserPermissions', {
      headers: {
        Authorization: 'Bearer ' + token,
      },
      method: 'POST',
    });

    if (response.ok) {
      console.log('User permissions refreshed successfully.');
    } else {
      if (response.status === 429) {
        console.error('Permissions refresh will be available in up to an hour.');
      } else {
        console.error(response);
      }
    }
  } catch (error) {
    console.error('Failure in making API call.' + error);
  }
};

export const getEmbedUrl = async (
  accessToken: string,
  onSuccess: (url: string) => void,
  onError: (errors: string[]) => void
): Promise<void> => {
  const reportUrl = `${config.powerBiApiUrl}v1.0/myorg/groups/${config.workspaceId}/reports/${config.reportId}`;

  try {
    const response = await fetch(reportUrl, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
      },
      method: 'GET',
    });

    const errorMessage: string[] = [];
    errorMessage.push('Error occurred while fetching the embed URL of the report');
    errorMessage.push('Request Id: ' + response.headers.get('requestId'));

    const body = await response.json();

    if (response.ok) {
      const url = body['embedUrl'];
      onSuccess(url);
    } else {
      errorMessage.push('Error ' + response.status + ': ' + body.error.code);
      onError(errorMessage);
    }
  } catch (error) {
    onError([error?.toString() || 'Unknown error occurred']);
  }
};
